// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.close-modal-button {
    position: absolute;
    right: 24px;
    background-color: transparent;
    border: none;
    outline: none;
    cursor: pointer;
    font-size: 26px;
    color: #5e1bff;
    padding: 0;
    margin: 0;
    transition: 0.3s ease, color 0.3s ease;
}

.close-modal-button:hover {
    scale: 1.15;
}

.modal-content {
    display: flex;
    flex-direction: column;
    gap: 10px;
    background: white;
    border-radius: 8px;
    text-align: center;
    min-width: 0;
    overflow-x: visible;
}

.trial-info-text {
    font-size: 2rem;
    font-weight: 700;
    text-align: center;
    margin: 0 0 5px 0;
    letter-spacing: -0.5px;
    line-height: 1.2;
    animation: fadeInDown 0.6s ease forwards;
    color: #5016d6;
}

@keyframes fadeInDown {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.modal-content h3 {
    font-size: 24px;
    color: #5e1bff;
    border-bottom: none;
    padding-bottom: 0;
}

/* Plan Slider Styles - matching pricing.js */
.plan-slider-wrapper {
    overflow-x: auto;
    overflow-y: hidden;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    padding: 0 0.5rem 10px 0.5rem;
    position: relative;
}

.plan-slider-wrapper::-webkit-scrollbar {
    height: 8px;
}

.plan-slider-wrapper::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.plan-slider-wrapper::-webkit-scrollbar-thumb {
    background: #5e1bff;
    border-radius: 4px;
}

.plan-slider-wrapper::-webkit-scrollbar-thumb:hover {
    background: #4a14c7;
}

.plan-slider {
    display: flex;
    flex-wrap: nowrap;
    gap: 20px;
    width: -moz-fit-content;
    width: fit-content;
    margin-top: 10px;
    padding-top: 15px;
    margin-bottom: 10px;
}

.plan-card {
    flex: 0 0 320px;
    width: 320px;
    background: #ffffff;
    border: 2px solid #e8e3ff;
    border-radius: 16px;
    padding: 1.5rem 1.25rem;
    box-shadow: 0 10px 20px rgba(94, 27, 255, 0.05);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    box-sizing: border-box;
    scroll-snap-align: center;
}

.plan-card:hover {
    box-shadow: 0 12px 24px rgba(94, 27, 255, 0.2);
}

.plan-card.highlighted {
    border: 3px solid #5e1bff;
    position: relative;
}

.plan-card.highlighted::before {
    content: 'Most popular';
    position: absolute;
    top: -14px;
    left: 50%;
    transform: translateX(-50%);
    background: #5e1bff;
    color: #fff;
    padding: 4px 12px;
    border-radius: 999px;
    font-size: 0.85rem;
    font-weight: 700;
    white-space: nowrap;
    letter-spacing: 0.5px;
}

.plan-card.current-plan {
    /* No special border for current plan */
}

.plan-card h3 {
    font-size: 1.4rem;
    color: #5e1bff;
    margin-bottom: 0.3rem;
    margin-top: 0;
}

.price-section {
    display: flex;
    flex-direction: column;
    margin-top: 0;
    margin-bottom: 0.4rem;
    gap: 0;
    min-height: auto;
}

.plan-price {
    font-size: 1.3rem;
    font-weight: bold;
    color: #000;
    margin: 0.2rem 0 0.1rem 0;
}

.per-month {
    font-size: 0.85rem;
    padding: 0;
    margin: 0;
    font-style: italic;
    color: #5b5b5b;
    margin: 0.1rem 0 0.2rem 0;
}

.after-trial {
    margin: 0;
    padding: 0;
    font-size: 0.8rem;
    color: #5e1bff;
    font-weight: 600;
}

.plan-features {
    list-style: none;
    padding: 0;
    margin: 0;
    margin-bottom: 1rem;
    flex-grow: 1;
}

.plan-features li {
    font-size: 0.9rem;
    margin-bottom: 0.75rem;
    color: #333;
    display: flex;
    align-items: center;
}

.plan-features svg {
    margin-bottom: -0.5px;
}

.plan-icons-included {
    margin-right: 0.5rem;
    color: #5e1bff;
    flex-shrink: 0;
}

.plan-icons-not-included {
    margin-right: 0.5rem;
    color: #e51616;
    flex-shrink: 0;
}

.plan-button {
    gap: 0.5em;
    padding: 0.75em 1.25em;
    font-weight: 600;
    font-size: 15px;
    border-radius: 12px;
    cursor: pointer;
    text-decoration: none;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    background-image: linear-gradient(135deg, #3d0d9d 0%, #5e1bff 100%);
    color: #fff;
    box-shadow: 0 6px 20px rgba(22, 2, 65, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.4);
    text-align: center;
    position: relative;
    z-index: 1;
    width: 100%;
    margin-top: auto;
}

.plan-button::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 12px;
    background-image: linear-gradient(135deg, #22083a 0%, #5016d6 100%);
    opacity: 0;
    transition: opacity 0.4s ease;
    z-index: -1;
    pointer-events: none;
}

.plan-button:hover::before {
    opacity: 1;
}

.plan-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(94, 27, 255, 0.45);
}

.plan-button:disabled {
    background-image: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);
    cursor: not-allowed;
    transform: translateY(0px) !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.plan-button:disabled::before {
    display: none;
}

/* Pricing Indicators */
.pricing-indicators {
    display: flex !important;
    justify-content: center;
    gap: 12px;
    margin-top: 1rem !important;
}

/* Scroll Arrow Buttons */
.scroll-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: rgba(94, 27, 255, 0.9);
    color: #fff;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    z-index: 10;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    transition: opacity 0.3s ease, background 0.3s ease;
}

.scroll-arrow:hover {
    background: rgba(74, 20, 199, 1);
}

.scroll-arrow.hidden {
    opacity: 0;
    pointer-events: none;
}

.scroll-arrow.left {
    left: 0;
}

.scroll-arrow.right {
    right: 0;
}

.indicator {
    width: 32px;
    height: 6px;
    border: 1px solid rgb(195, 195, 195);
    border-radius: 8px;
    background-color: transparent;
    transition: background-color 0.3s ease;
}

.indicator.active {
    background-color: #5e1bff;
    border: 1px solid #5e1bff;
}

/* Loading spinner */
.payment-loading-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 300px;
}

.payment-loading-container p {
    font-size: 20px;
    font-weight: 600;
}

.payment-spinner {
    border: 8px solid #f3f3f3;
    border-top: 8px solid #5e1bff;
    border-radius: 50%;
    width: 80px;
    height: 80px;
    animation: spin 1.1s linear infinite;
    margin-top: 20px;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

/* Billing Toggle */
.billing-toggle {
    position: relative;
    display: inline-flex;
    align-self: center;
    border: 1px solid #dddddd;
    border-radius: 8px;
    overflow: hidden;
    background: #f1f1f1;
    padding: 4px;
    outline: none;
}

.billing-thumb {
    position: absolute;
    top: 3px;
    left: 3px;
    width: calc(50% - 3px);
    height: calc(100% - 6px);
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    transition: left 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    pointer-events: none;
    z-index: 0;
}

.billing-toggle[data-cycle="year"] .billing-thumb {
    left: 50%;
}

.billing-toggle button {
    position: relative;
    z-index: 1;
    padding: 5px 20px;
    padding-top: 6px;
    font-size: 0.85rem;
    font-weight: 600;
    color: #969696;
    background: transparent;
    border: none;
    cursor: pointer;
    transition: color 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    outline: none;
    text-align: center;
    white-space: nowrap;
}

.billing-toggle button.active {
    color: #2f2f2f;
}

/* Price Swap Animation */
.price-swap {
    position: relative;
    min-height: 70px;
}

.price-swap .pane {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    opacity: 0;
    transform: translateY(8px);
    transition: opacity 280ms ease-out, transform 280ms ease-out;
    pointer-events: none;
}

.price-swap .pane.show {
    position: relative;
    opacity: 1;
    transform: translateY(0);
    transition: opacity 520ms ease-out 120ms, transform 520ms ease-out 120ms;
    pointer-events: auto;
}

.price-swap.no-anim .pane {
    transition: none;
}

/* Yearly Crossout Pricing */
.yearly-crossout {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0 6px;
    margin: 0.2rem 0 0 0;
}

.yearly-crossout .old-price {
    text-decoration: line-through;
    color: #999;
    font-size: 1rem;
    opacity: 0;
    transition: opacity 400ms ease-out 200ms;
}

.price-swap .pane.show .old-price {
    opacity: 1;
}

.yearly-crossout .arrow {
    color: #999;
    font-size: 0.9rem;
}

.yearly-crossout .new-price {
    font-weight: 700;
    font-size: 1.3rem;
    color: #000;
}

.yearly-crossout .deal-tag {
    background: linear-gradient(135deg, #5e1bff 0%, #8b5cf6 100%);
    color: #fff;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 0.8rem;
    font-weight: 700;
    opacity: 0;
    transform: scale(0.8);
    transition: opacity 300ms ease-out 250ms, transform 300ms ease-out 250ms;
}

.price-swap .pane.show .deal-tag {
    opacity: 1;
    transform: scale(1);
}

.yearly-crossout .billed-annually {
    flex-basis: 100%;
    margin: -4px 0 0.2rem 0;
    font-size: 0.85rem;
    font-style: italic;
    color: #5b5b5b;
}

/* Desktop styles */
@media (min-width: 769px) {
    .plan-card {
        flex: 0 0 320px;
        width: 320px;
    }
    
    .pricing-indicators {
        display: flex;
    }
}

/* Mobile styles */
@media (max-width: 768px) {
    .modal-content {
        gap: 15px;
    }

    .trial-info-text {
        font-size: 1.5rem;
    }

    .plan-card {
        flex: 0 0 280px;
        width: 280px;
        padding: 1.25rem 1rem;
    }

    .plan-card:hover {
        transform: translateY(0px);
        box-shadow: 0 10px 20px rgba(94, 27, 255, 0.05);
    }

    .plan-card h3 {
        font-size: 1.4rem;
    }

    .plan-price {
        font-size: 1.3rem;
    }

    .plan-features li {
        font-size: 0.85rem;
        margin-bottom: 0.7rem;
    }

    .plan-button {
        font-size: 14px;
        padding: 0.65em 1em;
    }

    .plan-button:hover {
        transform: translateY(0px);
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/subscriptionModal.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,eAAe;IACf,eAAe;IACf,cAAc;IACd,UAAU;IACV,SAAS;IACT,sCAAsC;AAC1C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA,6CAA6C;AAC7C;IACI,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,iCAAiC;IACjC,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,SAAS;IACT,uBAAkB;IAAlB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,+CAA+C;IAC/C,qDAAqD;IACrD,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,qBAAqB;IACrB,MAAM;IACN,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,qDAAqD;IACrD,mEAAmE;IACnE,WAAW;IACX,2CAA2C;IAC3C,0CAA0C;IAC1C,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,mBAAmB;IACnB,mEAAmE;IACnE,UAAU;IACV,6BAA6B;IAC7B,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,mEAAmE;IACnE,mBAAmB;IACnB,qCAAqC;IACrC,yCAAyC;AAC7C;;AAEA;IACI,aAAa;AACjB;;AAEA,uBAAuB;AACvB;IACI,wBAAwB;IACxB,uBAAuB;IACvB,SAAS;IACT,2BAA2B;AAC/B;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kCAAkC;IAClC,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,wCAAwC;IACxC,mDAAmD;AACvD;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,6BAA6B;IAC7B,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;IACzC,kDAAkD;IAClD,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,mDAAmD;IACnD,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,UAAU;IACV,0BAA0B;IAC1B,4DAA4D;IAC5D,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,wBAAwB;IACxB,wEAAwE;IACxE,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,eAAe;IACf,UAAU;IACV,wCAAwC;AAC5C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,6DAA6D;IAC7D,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,wEAAwE;AAC5E;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA,kBAAkB;AAClB;IACI;QACI,SAAS;IACb;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,qBAAqB;IACzB;;IAEA;QACI,0BAA0B;QAC1B,+CAA+C;IACnD;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,qBAAqB;IACzB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".close-modal-button {\r\n    position: absolute;\r\n    right: 24px;\r\n    background-color: transparent;\r\n    border: none;\r\n    outline: none;\r\n    cursor: pointer;\r\n    font-size: 26px;\r\n    color: #5e1bff;\r\n    padding: 0;\r\n    margin: 0;\r\n    transition: 0.3s ease, color 0.3s ease;\r\n}\r\n\r\n.close-modal-button:hover {\r\n    scale: 1.15;\r\n}\r\n\r\n.modal-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    background: white;\r\n    border-radius: 8px;\r\n    text-align: center;\r\n    min-width: 0;\r\n    overflow-x: visible;\r\n}\r\n\r\n.trial-info-text {\r\n    font-size: 2rem;\r\n    font-weight: 700;\r\n    text-align: center;\r\n    margin: 0 0 5px 0;\r\n    letter-spacing: -0.5px;\r\n    line-height: 1.2;\r\n    animation: fadeInDown 0.6s ease forwards;\r\n    color: #5016d6;\r\n}\r\n\r\n@keyframes fadeInDown {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(-10px);\r\n    }\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n.modal-content h3 {\r\n    font-size: 24px;\r\n    color: #5e1bff;\r\n    border-bottom: none;\r\n    padding-bottom: 0;\r\n}\r\n\r\n/* Plan Slider Styles - matching pricing.js */\r\n.plan-slider-wrapper {\r\n    overflow-x: auto;\r\n    overflow-y: hidden;\r\n    scroll-snap-type: x mandatory;\r\n    -webkit-overflow-scrolling: touch;\r\n    padding: 0 0.5rem 10px 0.5rem;\r\n    position: relative;\r\n}\r\n\r\n.plan-slider-wrapper::-webkit-scrollbar {\r\n    height: 8px;\r\n}\r\n\r\n.plan-slider-wrapper::-webkit-scrollbar-track {\r\n    background: #f1f1f1;\r\n    border-radius: 4px;\r\n}\r\n\r\n.plan-slider-wrapper::-webkit-scrollbar-thumb {\r\n    background: #5e1bff;\r\n    border-radius: 4px;\r\n}\r\n\r\n.plan-slider-wrapper::-webkit-scrollbar-thumb:hover {\r\n    background: #4a14c7;\r\n}\r\n\r\n.plan-slider {\r\n    display: flex;\r\n    flex-wrap: nowrap;\r\n    gap: 20px;\r\n    width: fit-content;\r\n    margin-top: 10px;\r\n    padding-top: 15px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.plan-card {\r\n    flex: 0 0 320px;\r\n    width: 320px;\r\n    background: #ffffff;\r\n    border: 2px solid #e8e3ff;\r\n    border-radius: 16px;\r\n    padding: 1.5rem 1.25rem;\r\n    box-shadow: 0 10px 20px rgba(94, 27, 255, 0.05);\r\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n    text-align: left;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    box-sizing: border-box;\r\n    scroll-snap-align: center;\r\n}\r\n\r\n.plan-card:hover {\r\n    box-shadow: 0 12px 24px rgba(94, 27, 255, 0.2);\r\n}\r\n\r\n.plan-card.highlighted {\r\n    border: 3px solid #5e1bff;\r\n    position: relative;\r\n}\r\n\r\n.plan-card.highlighted::before {\r\n    content: 'Most popular';\r\n    position: absolute;\r\n    top: -14px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    background: #5e1bff;\r\n    color: #fff;\r\n    padding: 4px 12px;\r\n    border-radius: 999px;\r\n    font-size: 0.85rem;\r\n    font-weight: 700;\r\n    white-space: nowrap;\r\n    letter-spacing: 0.5px;\r\n}\r\n\r\n.plan-card.current-plan {\r\n    /* No special border for current plan */\r\n}\r\n\r\n.plan-card h3 {\r\n    font-size: 1.4rem;\r\n    color: #5e1bff;\r\n    margin-bottom: 0.3rem;\r\n    margin-top: 0;\r\n}\r\n\r\n.price-section {\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin-top: 0;\r\n    margin-bottom: 0.4rem;\r\n    gap: 0;\r\n    min-height: auto;\r\n}\r\n\r\n.plan-price {\r\n    font-size: 1.3rem;\r\n    font-weight: bold;\r\n    color: #000;\r\n    margin: 0.2rem 0 0.1rem 0;\r\n}\r\n\r\n.per-month {\r\n    font-size: 0.85rem;\r\n    padding: 0;\r\n    margin: 0;\r\n    font-style: italic;\r\n    color: #5b5b5b;\r\n    margin: 0.1rem 0 0.2rem 0;\r\n}\r\n\r\n.after-trial {\r\n    margin: 0;\r\n    padding: 0;\r\n    font-size: 0.8rem;\r\n    color: #5e1bff;\r\n    font-weight: 600;\r\n}\r\n\r\n.plan-features {\r\n    list-style: none;\r\n    padding: 0;\r\n    margin: 0;\r\n    margin-bottom: 1rem;\r\n    flex-grow: 1;\r\n}\r\n\r\n.plan-features li {\r\n    font-size: 0.9rem;\r\n    margin-bottom: 0.75rem;\r\n    color: #333;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.plan-features svg {\r\n    margin-bottom: -0.5px;\r\n}\r\n\r\n.plan-icons-included {\r\n    margin-right: 0.5rem;\r\n    color: #5e1bff;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.plan-icons-not-included {\r\n    margin-right: 0.5rem;\r\n    color: #e51616;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.plan-button {\r\n    gap: 0.5em;\r\n    padding: 0.75em 1.25em;\r\n    font-weight: 600;\r\n    font-size: 15px;\r\n    border-radius: 12px;\r\n    cursor: pointer;\r\n    text-decoration: none;\r\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n    background-image: linear-gradient(135deg, #3d0d9d 0%, #5e1bff 100%);\r\n    color: #fff;\r\n    box-shadow: 0 6px 20px rgba(22, 2, 65, 0.3);\r\n    border: 1px solid rgba(255, 255, 255, 0.4);\r\n    text-align: center;\r\n    position: relative;\r\n    z-index: 1;\r\n    width: 100%;\r\n    margin-top: auto;\r\n}\r\n\r\n.plan-button::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    border-radius: 12px;\r\n    background-image: linear-gradient(135deg, #22083a 0%, #5016d6 100%);\r\n    opacity: 0;\r\n    transition: opacity 0.4s ease;\r\n    z-index: -1;\r\n    pointer-events: none;\r\n}\r\n\r\n.plan-button:hover::before {\r\n    opacity: 1;\r\n}\r\n\r\n.plan-button:hover {\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 8px 24px rgba(94, 27, 255, 0.45);\r\n}\r\n\r\n.plan-button:disabled {\r\n    background-image: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);\r\n    cursor: not-allowed;\r\n    transform: translateY(0px) !important;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.plan-button:disabled::before {\r\n    display: none;\r\n}\r\n\r\n/* Pricing Indicators */\r\n.pricing-indicators {\r\n    display: flex !important;\r\n    justify-content: center;\r\n    gap: 12px;\r\n    margin-top: 1rem !important;\r\n}\r\n\r\n/* Scroll Arrow Buttons */\r\n.scroll-arrow {\r\n    position: absolute;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    width: 36px;\r\n    height: 36px;\r\n    border-radius: 50%;\r\n    background: rgba(94, 27, 255, 0.9);\r\n    color: #fff;\r\n    border: none;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 18px;\r\n    z-index: 10;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\r\n    transition: opacity 0.3s ease, background 0.3s ease;\r\n}\r\n\r\n.scroll-arrow:hover {\r\n    background: rgba(74, 20, 199, 1);\r\n}\r\n\r\n.scroll-arrow.hidden {\r\n    opacity: 0;\r\n    pointer-events: none;\r\n}\r\n\r\n.scroll-arrow.left {\r\n    left: 0;\r\n}\r\n\r\n.scroll-arrow.right {\r\n    right: 0;\r\n}\r\n\r\n.indicator {\r\n    width: 32px;\r\n    height: 6px;\r\n    border: 1px solid rgb(195, 195, 195);\r\n    border-radius: 8px;\r\n    background-color: transparent;\r\n    transition: background-color 0.3s ease;\r\n}\r\n\r\n.indicator.active {\r\n    background-color: #5e1bff;\r\n    border: 1px solid #5e1bff;\r\n}\r\n\r\n/* Loading spinner */\r\n.payment-loading-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    min-height: 300px;\r\n}\r\n\r\n.payment-loading-container p {\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n}\r\n\r\n.payment-spinner {\r\n    border: 8px solid #f3f3f3;\r\n    border-top: 8px solid #5e1bff;\r\n    border-radius: 50%;\r\n    width: 80px;\r\n    height: 80px;\r\n    animation: spin 1.1s linear infinite;\r\n    margin-top: 20px;\r\n}\r\n\r\n@keyframes spin {\r\n    0% { transform: rotate(0deg); }\r\n    100% { transform: rotate(360deg); }\r\n}\r\n\r\n/* Billing Toggle */\r\n.billing-toggle {\r\n    position: relative;\r\n    display: inline-flex;\r\n    align-self: center;\r\n    border: 1px solid #dddddd;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    background: #f1f1f1;\r\n    padding: 4px;\r\n    outline: none;\r\n}\r\n\r\n.billing-thumb {\r\n    position: absolute;\r\n    top: 3px;\r\n    left: 3px;\r\n    width: calc(50% - 3px);\r\n    height: calc(100% - 6px);\r\n    background: #ffffff;\r\n    border-radius: 6px;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\r\n    transition: left 0.6s cubic-bezier(0.4, 0, 0.2, 1);\r\n    pointer-events: none;\r\n    z-index: 0;\r\n}\r\n\r\n.billing-toggle[data-cycle=\"year\"] .billing-thumb {\r\n    left: 50%;\r\n}\r\n\r\n.billing-toggle button {\r\n    position: relative;\r\n    z-index: 1;\r\n    padding: 5px 20px;\r\n    padding-top: 6px;\r\n    font-size: 0.85rem;\r\n    font-weight: 600;\r\n    color: #969696;\r\n    background: transparent;\r\n    border: none;\r\n    cursor: pointer;\r\n    transition: color 0.6s cubic-bezier(0.4, 0, 0.2, 1);\r\n    outline: none;\r\n    text-align: center;\r\n    white-space: nowrap;\r\n}\r\n\r\n.billing-toggle button.active {\r\n    color: #2f2f2f;\r\n}\r\n\r\n/* Price Swap Animation */\r\n.price-swap {\r\n    position: relative;\r\n    min-height: 70px;\r\n}\r\n\r\n.price-swap .pane {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    opacity: 0;\r\n    transform: translateY(8px);\r\n    transition: opacity 280ms ease-out, transform 280ms ease-out;\r\n    pointer-events: none;\r\n}\r\n\r\n.price-swap .pane.show {\r\n    position: relative;\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n    transition: opacity 520ms ease-out 120ms, transform 520ms ease-out 120ms;\r\n    pointer-events: auto;\r\n}\r\n\r\n.price-swap.no-anim .pane {\r\n    transition: none;\r\n}\r\n\r\n/* Yearly Crossout Pricing */\r\n.yearly-crossout {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    gap: 0 6px;\r\n    margin: 0.2rem 0 0 0;\r\n}\r\n\r\n.yearly-crossout .old-price {\r\n    text-decoration: line-through;\r\n    color: #999;\r\n    font-size: 1rem;\r\n    opacity: 0;\r\n    transition: opacity 400ms ease-out 200ms;\r\n}\r\n\r\n.price-swap .pane.show .old-price {\r\n    opacity: 1;\r\n}\r\n\r\n.yearly-crossout .arrow {\r\n    color: #999;\r\n    font-size: 0.9rem;\r\n}\r\n\r\n.yearly-crossout .new-price {\r\n    font-weight: 700;\r\n    font-size: 1.3rem;\r\n    color: #000;\r\n}\r\n\r\n.yearly-crossout .deal-tag {\r\n    background: linear-gradient(135deg, #5e1bff 0%, #8b5cf6 100%);\r\n    color: #fff;\r\n    padding: 4px 10px;\r\n    border-radius: 999px;\r\n    font-size: 0.8rem;\r\n    font-weight: 700;\r\n    opacity: 0;\r\n    transform: scale(0.8);\r\n    transition: opacity 300ms ease-out 250ms, transform 300ms ease-out 250ms;\r\n}\r\n\r\n.price-swap .pane.show .deal-tag {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n}\r\n\r\n.yearly-crossout .billed-annually {\r\n    flex-basis: 100%;\r\n    margin: -4px 0 0.2rem 0;\r\n    font-size: 0.85rem;\r\n    font-style: italic;\r\n    color: #5b5b5b;\r\n}\r\n\r\n/* Desktop styles */\r\n@media (min-width: 769px) {\r\n    .plan-card {\r\n        flex: 0 0 320px;\r\n        width: 320px;\r\n    }\r\n    \r\n    .pricing-indicators {\r\n        display: flex;\r\n    }\r\n}\r\n\r\n/* Mobile styles */\r\n@media (max-width: 768px) {\r\n    .modal-content {\r\n        gap: 15px;\r\n    }\r\n\r\n    .trial-info-text {\r\n        font-size: 1.5rem;\r\n    }\r\n\r\n    .plan-card {\r\n        flex: 0 0 280px;\r\n        width: 280px;\r\n        padding: 1.25rem 1rem;\r\n    }\r\n\r\n    .plan-card:hover {\r\n        transform: translateY(0px);\r\n        box-shadow: 0 10px 20px rgba(94, 27, 255, 0.05);\r\n    }\r\n\r\n    .plan-card h3 {\r\n        font-size: 1.4rem;\r\n    }\r\n\r\n    .plan-price {\r\n        font-size: 1.3rem;\r\n    }\r\n\r\n    .plan-features li {\r\n        font-size: 0.85rem;\r\n        margin-bottom: 0.7rem;\r\n    }\r\n\r\n    .plan-button {\r\n        font-size: 14px;\r\n        padding: 0.65em 1em;\r\n    }\r\n\r\n    .plan-button:hover {\r\n        transform: translateY(0px);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
